import { Client } from 'hooks/webapi/useClient';
import { memo } from 'react';
import styles from './ConsBanner.module.scss';

import { Paragraph } from 'components';
import { useTranslation } from 'react-i18next';
import CloseIcon from 'assets/icons/close.svg?react';
import NewLabelIcon from 'assets/icons/new-label-big.svg?react';

type Props = {
  onClose: () => void;
};

export const showNewConsTagAccordingtoBE = (
  client?: Client | null | undefined,
) => !client?.loansCountByProductKind?.VIVUS_IL;

export default memo(function ConsBanner({ onClose }: Props) {
  const { t } = useTranslation('repeated_loan');
  return (
    <div className={styles.wrapper} data-test="cons-banner">
      <div className={styles.container}>
        <div className={styles.inner}>
          <NewLabelIcon data-test="cons-banner-icon" />

          <Paragraph type="medium" className={styles.text}>
            {t('cons_banner')}
          </Paragraph>
        </div>
      </div>

      <CloseIcon
        data-test="cons-banner-close"
        onClick={onClose}
        className={styles.close}
      />
    </div>
  );
});
